// Color Theme Configuration for Public Event Pages
// Version: 2.0 - Coastal Silk is now default, Dark Elegant renamed
// CMYK values converted to RGB/Hex for web use

export const colorThemes = {
  darkElegant: {
    name: "Dark Elegant",
    colors: {
      background: "#020617",
      cardBackground: "rgba(30, 41, 59, 0.5)",
      primary: "#D4AF37",
      primaryHover: "#B5952F",
      text: "#ffffff",
      textSecondary: "#94a3b8",
      textMuted: "#64748b",
      accent: "#D4AF37",
      border: "#334155",
      inputBackground: "rgba(15, 23, 42, 0.5)",
      success: "#22c55e",
      tableButton: "#D4AF37",
      tableButtonText: "#020617",
    }
  },
  
  quietLuxuryGarden: {
    name: "Quiet Luxury Garden",
    colors: {
      background: "#FAF9F6",       // Cloud Dancer (soft off-white)
      cardBackground: "#F5F0E8",    // Sand/Beige tint
      primary: "#6B7B4C",           // Olive Green
      primaryHover: "#5A6840",
      text: "#4A4743",              // Warm Taupe dark
      textSecondary: "#6B6560",
      textMuted: "#8B8580",
      accent: "#6B7B4C",            // Olive Green
      border: "#D4CFC5",            // Sand/Beige border
      inputBackground: "#FFFFFF",
      success: "#6B7B4C",
      tableButton: "#6B7B4C",       // Olive Green
      tableButtonText: "#FAF9F6",
    }
  },
  
  mediterraneanRadiance: {
    name: "Mediterranean Radiance",
    colors: {
      background: "#0A3D6E",        // Cobalt Blue dark
      cardBackground: "rgba(10, 61, 110, 0.7)",
      primary: "#FFD700",           // Canary Yellow
      primaryHover: "#E6C200",
      text: "#FFFEF5",              // Ivory
      textSecondary: "#D4D0C0",
      textMuted: "#A0A090",
      accent: "#FFD700",            // Canary Yellow
      border: "#1A5A8E",
      inputBackground: "rgba(10, 61, 110, 0.5)",
      success: "#FFD700",
      tableButton: "#FFD700",       // Canary Yellow
      tableButtonText: "#0A3D6E",
    }
  },
  
  lavenderWhisper: {
    name: "Lavender Whisper",
    colors: {
      background: "#F8F5FC",        // Light lavender tint
      cardBackground: "#FFFFFF",
      primary: "#9B8AC4",           // Lavender
      primaryHover: "#8575B0",
      text: "#4A4A5A",
      textSecondary: "#6B6B7B",
      textMuted: "#9090A0",
      accent: "#E8B4B8",            // Blush Pink
      border: "#E0D8EC",
      inputBackground: "#FFFFFF",
      success: "#7B9B6B",           // Sage Green
      tableButton: "#9B8AC4",       // Lavender
      tableButtonText: "#FFFFFF",
    }
  },
  
  bordeauxRomance: {
    name: "Bordeaux Romance",
    colors: {
      background: "#1A0A10",        // Very dark burgundy
      cardBackground: "rgba(45, 20, 30, 0.7)",
      primary: "#8B2346",           // Burgundy
      primaryHover: "#6B1A36",
      text: "#FAF0F2",              // Light blush
      textSecondary: "#D4A0A8",     // Dusty Rose light
      textMuted: "#A08088",
      accent: "#D4AF7A",            // Champagne Gold
      border: "#4A2030",
      inputBackground: "rgba(30, 15, 20, 0.5)",
      success: "#D4AF7A",           // Champagne Gold
      tableButton: "#8B2346",       // Burgundy
      tableButtonText: "#FAF0F2",
    }
  },
  
  desertSunsetDream: {
    name: "Desert Sunset Dream",
    colors: {
      background: "#FDF8F3",        // Warm off-white
      cardBackground: "#FFFFFF",
      primary: "#E07850",           // Coral
      primaryHover: "#C86840",
      text: "#5A4035",              // Terracotta dark
      textSecondary: "#7A6055",
      textMuted: "#9A8075",
      accent: "#FFB090",            // Peach
      border: "#E8DDD5",            // Warm Neutral
      inputBackground: "#FFFFFF",
      success: "#E07850",           // Coral
      tableButton: "#C86840",       // Terracotta
      tableButtonText: "#FFFFFF",
    }
  },

  champagneAtelier: {
    name: "Champagne Atelier",
    colors: {
      background: "#F6F4EF",        // Soft cream
      cardBackground: "#FFFFFF",
      primary: "#B08D57",           // Champagne gold
      primaryHover: "#9A7A4A",
      text: "#1e293b",              // Dark slate
      textSecondary: "#A89283",     // Warm taupe
      textMuted: "#A89283",
      accent: "#E9D1C6",            // Blush pink
      border: "#E9D1C6",
      inputBackground: "#FFFFFF",
      success: "#B08D57",
      tableButton: "#B08D57",
      tableButtonText: "#F6F4EF",
    }
  },

  coastalSilk: {
    name: "Coastal Silk (Default)",
    colors: {
      background: "#F6F4EF",        // Soft cream
      cardBackground: "#FFFFFF",
      primary: "#A7B7A8",           // Sage green
      primaryHover: "#8FA090",
      text: "#1e293b",              // Dark slate
      textSecondary: "#CFCFCB",     // Warm gray
      textMuted: "#CFCFCB",
      accent: "#AFC2D3",            // Soft blue
      border: "#AFC2D3",
      inputBackground: "#FFFFFF",
      success: "#A7B7A8",
      tableButton: "#A7B7A8",
      tableButtonText: "#1e293b",
    }
  },

  rosewoodReverie: {
    name: "Rosewood Reverie",
    colors: {
      background: "#F6F4EF",        // Soft cream
      cardBackground: "#FFFFFF",
      primary: "#7C4B4D",           // Deep rosewood
      primaryHover: "#6A3E40",
      text: "#1e293b",              // Dark slate
      textSecondary: "#8A6D63",     // Warm brown
      textMuted: "#8A6D63",
      accent: "#C7B6C8",            // Soft lavender
      border: "#C7B6C8",
      inputBackground: "#FFFFFF",
      success: "#7C4B4D",
      tableButton: "#7C4B4D",
      tableButtonText: "#F6F4EF",
    }
  },

  tuscanSundown: {
    name: "Tuscan Sundown",
    colors: {
      background: "#F6F4EF",        // Soft cream
      cardBackground: "#FFFFFF",
      primary: "#6F7B57",           // Olive green
      primaryHover: "#5E6A48",
      text: "#1e293b",              // Dark slate
      textSecondary: "#D9C6B0",     // Warm sand
      textMuted: "#D9C6B0",
      accent: "#C07A6A",            // Terracotta
      border: "#C07A6A",
      inputBackground: "#FFFFFF",
      success: "#6F7B57",
      tableButton: "#6F7B57",
      tableButtonText: "#F6F4EF",
    }
  },

  pastelPromenade: {
    name: "Pastel Promenade",
    colors: {
      background: "#F6F4EF",        // Soft cream
      cardBackground: "#FFFFFF",
      primary: "#BFD1B2",           // Soft mint
      primaryHover: "#A8C09A",
      text: "#1e293b",              // Dark slate
      textSecondary: "#F3B7A6",     // Soft peach
      textMuted: "#F3B7A6",
      accent: "#F2E3A4",            // Soft yellow
      border: "#F2E3A4",
      inputBackground: "#FFFFFF",
      success: "#BFD1B2",
      tableButton: "#BFD1B2",
      tableButtonText: "#1e293b",
    }
  }
};

// Default custom colors template (based on Coastal Silk)
export const defaultCustomColors = {
  background: "#F6F4EF",
  primary: "#A7B7A8",
  accent: "#AFC2D3",
  tableButton: "#A7B7A8",
  tableButtonText: "#1e293b",
  text: "#1e293b",
  textSecondary: "#CFCFCB"
};

export const getTheme = (themeId) => {
  // Handle legacy 'default' theme by mapping to coastalSilk
  if (!themeId || themeId === 'default') {
    return colorThemes.coastalSilk;
  }
  return colorThemes[themeId] || colorThemes.coastalSilk;
};

// Build theme from custom colors
export const buildCustomTheme = (customColors) => {
  const base = colorThemes.coastalSilk.colors;
  return {
    name: "Custom Theme",
    colors: {
      ...base,
      background: customColors?.background || base.background,
      primary: customColors?.primary || base.primary,
      primaryHover: customColors?.primary || base.primaryHover,
      accent: customColors?.accent || base.accent,
      tableButton: customColors?.tableButton || base.tableButton,
      tableButtonText: customColors?.tableButtonText || base.tableButtonText,
      text: customColors?.text || base.text,
      textSecondary: customColors?.textSecondary || base.textSecondary,
      // Derive other colors from primary/background
      cardBackground: customColors?.background ? `${customColors.background}cc` : base.cardBackground,
      border: customColors?.background ? adjustColor(customColors.background, 30) : base.border,
      inputBackground: customColors?.background ? `${customColors.background}80` : base.inputBackground,
      textMuted: customColors?.textSecondary || base.textMuted,
      success: customColors?.primary || base.success,
    }
  };
};

// Helper to adjust color brightness
function adjustColor(hex, amount) {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.min(255, Math.max(0, (num >> 16) + amount));
  const g = Math.min(255, Math.max(0, ((num >> 8) & 0x00FF) + amount));
  const b = Math.min(255, Math.max(0, (num & 0x0000FF) + amount));
  return `#${(1 << 24 | r << 16 | g << 8 | b).toString(16).slice(1)}`;
}

// Calculate contrast ratio between two colors
export const getContrastRatio = (color1, color2) => {
  const getLuminance = (hex) => {
    const rgb = parseInt(hex.replace('#', ''), 16);
    const r = ((rgb >> 16) & 0xff) / 255;
    const g = ((rgb >> 8) & 0xff) / 255;
    const b = (rgb & 0xff) / 255;
    
    const toLinear = (c) => c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    
    return 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);
  };
  
  const l1 = getLuminance(color1);
  const l2 = getLuminance(color2);
  const lighter = Math.max(l1, l2);
  const darker = Math.min(l1, l2);
  
  return (lighter + 0.05) / (darker + 0.05);
};

// Check if contrast meets WCAG AA standard (4.5:1 for normal text)
export const hasGoodContrast = (textColor, backgroundColor) => {
  return getContrastRatio(textColor, backgroundColor) >= 4.5;
};

export const themeOptions = [
  { id: 'coastalSilk', name: colorThemes.coastalSilk.name },
  ...Object.entries(colorThemes)
    .filter(([id]) => id !== 'coastalSilk')
    .map(([id, theme]) => ({ id, name: theme.name }))
];
